module.exports = __webpack_public_path__ + "img/about_honor.29ff5956.jpg";